const { _require, localStorage, navigator } = window;
const EXPIRATION_TIME = 3600000; // in milliseconds

function getDateNow() {
  return new Date().getTime();
}

function isTrackingExpired() {
  if (localStorage) {
    const expiringTime = parseInt(localStorage.getItem('net-info-expires-at'), 10);
    return !expiringTime || expiringTime < getDateNow();
  }

  return false;
}

class NetworkInformationTracking {
  static track() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    // Confirm compatibility and track just once per EXPIRATION_TIME
    if (connection && isTrackingExpired()) {
      /*
      * downlink      =>  Effective bandwidth estimate
      * effectiveType =>  Effective connection type determined using a combination of recently
      *                   observed rtt and downlink values
      * saveData      =>  True if the user has requested a reduced data usage mode from the user agent
      * rtt           =>  Effective round-trip time estimate
      */
      const properties = {
        downlink: `${connection.downlink} Mb/s`,
        effectiveType: connection.effectiveType,
        saveData: connection.saveData,
        rtt: `${connection.rtt} ms`,
      };

      _require(['metrics'], () => {
        const { trackable, Metrics } = window;
        trackable.eventTracker.track(Metrics.Events.ConnectionInformation, properties);
      });

      localStorage.setItem('net-info-expires-at', getDateNow() + EXPIRATION_TIME);
    }
  }
}

export default NetworkInformationTracking;
